import Immutable from 'seamless-immutable';
import createReducer from '../helpers/createReducer';
import state from '../store/education';

export default createReducer(state, {
  SET_EDUCATION_DATA: (state, { data }) => Immutable({ ...state, ...data }),
});
